import totalIcon from '../../../../../../Assets/images/total-icon.svg';
import completedIcon from '../../../../../../Assets/images/completed-icon.svg';
import progressIcon from '../../../../../../Assets/images/progress-icon.svg';
import cancelIcon from '../../../../../../Assets/images/cancel-icon.svg';

const SingleCard = function ({ ItemData }) {

  const { cardTitle, cardContent } = ItemData
  let cardImage;
  
  switch (cardTitle) {
    case "Total":
      cardImage = totalIcon;
      break;
    case "Completed":
      cardImage = completedIcon;
      break;
    case "In Progress":
      cardImage = progressIcon;
      break;
    case "Cancelled":
      cardImage = cancelIcon;
      break;
    case "Paid":
      cardImage = completedIcon;
      break;
    case "Pending":
      cardImage = progressIcon;
      break;
  }

  return (
    <div className="col right-border">
      <p className="mc-head">{cardTitle}</p>
      <div className="mc-content">
        <img src={cardImage} />
        <p>{cardContent}</p></div>
    </div>
  )
}


export const Cards = ({ cards }) => {

  const { MainTitle, cardDetails } = cards

  return (
    <div className="white-wraper">
      <h2 className="add-margin">{MainTitle}</h2>
      <div className="overview-content">
        <div className="row mobilecard-row">
          {cardDetails.map((cardDetail, index) => (
            <SingleCard ItemData={cardDetail} key={index} />
          ))
          }
        </div>
      </div>
    </div>
  )
}